import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import moment from 'moment'
import Wrapper from '../../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline, tableHeightWithSparklineSingle } from "../../../../styleVariables";
import { connect } from "react-redux";
import TopCard from '../../../components/TopCard/TopCard';
import TapLayout from '../../../components/PageLayout/TabLayOut';
import Grid from '@material-ui/core/Grid';
import MUIDataTable from "mui-datatables";
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { getSinglePartyLedgerData, getSinglePartyLedgerDataV2, getSinglePartyPDFReport } from '../../../../store/actions/homeActionCreator';
import { numberFormat, getTripStartDateFilterValues, getDateInStringDDMMMYYYY, getRequestTimeInMillis, getDatePickerDateInStringDDMMMYYYY } from "../../../../utils/utils";
import {
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  TRIP_FILTER_STATUS,
  TRIP_FILTER_STATUS_MAPPING,
  PAYMENT_CHIPS,
  TRIP_STATUS_LABELS
} from "../../../../store/constants";
import {
  getTripDetailsV3,
  emptySingleTripData
} from "../../../../store/actions/tripActionCreator";
import { trackEvent } from '../../../../analytics';
import useStyles from '../../css/listing';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ActionButton from '../../../components/Actions/ActionButton';
import ColumnActions from '../../../components/Actions/ColumnActions';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Button from '@material-ui/core/Button';
import ReportsDialog from '../../../components/ReportsDialog/ReportsDialog';
import TripTimelineAction from '../../../components/Trip/TripTimelineActionDialog';
import DateFilter from '../../../components/FilterComponent/DateFilter';
import CustomDateFilterDialog from '../../../components/FilterComponent/CustomDateFilter';
import TripStatusFilter from '../../../components/FilterComponent/TripStatusFIlter';
import { updateTripsTabFilter, getSinglePartyCollectionReminder, updatePartyReminder, addPartyReminder } from '../../../../store/actions/partiesActionCreator';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
  DatePicker
} from '@material-ui/pickers';
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo,defaultPageSize,defaultDebounceMs } from '../../../../paginationVariables';
import CardSelectionDialog from '../../../components/Dialog/CardSelectionDialog';
import PassBookReportDialog from '../../../components/ReportsDialog/PassBookReportDialog';
import OpeningBalanceDetailsSideBar from '../../../components/Trip/OpeningBalanceDetailsSideBar';
const today = new Date()
const tomorrow = new Date(today)
tomorrow.setDate(tomorrow.getDate() + 1)
const TripsTab = ({ user, location, parties, dispatchUpdateTripsTabFilter,
  dispatchGetCollectionReminder,
  dispatchGetSinglePartyLedgerAction,
  dispatchAddCollectionReminder,
  disPatchEmptySingleTripData,
  dispatchTripDetailsAction,
  dispatchUpdateCollectionReminder
}) => {
  const [pdfOpen, setPdfOpen] = useState(false);
  const [changeFlag, setChangeFlag] = useState(false);
  const [dateSelectOpen, setDateSelectOpen] = useState(false);
  const [reminderDate, setReminderDate] = useState(parties && parties.collectionReminder && parties.collectionReminder.reminder ? parties.collectionReminder.reminder : new Date());
  const [searchText, setSearchText] = useState("");
  const [customFilter, setCustomFilter] = useState(false);
  const [customFilterValue, setCustomFilterValue] = useState({});
  const [currentPageNo,setCurrentPageNo]  = useState(defaultPageNo);
  const [currentPageSize,setCurrentPageSize]  = useState(defaultPageSize);
  const [viewReportDialog,setViewReportDialog] = useState(false);
  const [passbookPdfOpen,setPassbookPdfOpen] = useState(false)
  const [partyLedger, setPartyLedger] = useState([]);
  const [loadingText, setLoadingText] = useState("Sorry, no Trips found");
  const [selectedRow,setSelectedRow] = useState("");
  const [detailsOpen,setDetailsOpen] = useState("");

  let history = useHistory();
  const classes = useStyles();
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let partId = "";
  if (path[path.length - 1]) {
    partId = path[path.length - 1];
  }
  const getDateRangeValue = () => {
    let date = `${moment(dateFilterValues[selectedFilterDate]["startDateRange"]["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(dateFilterValues[selectedFilterDate]["startDateRange"]["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
    if (customFilterValue && customFilterValue.startTimeEpoch) {
      date = `${moment(customFilterValue["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(customFilterValue["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
    }
    return [date]
  }
  const partyLedgerRequestData = {
    fleetOwnerId: user.userInfo.entityId,
    pageNo: defaultPageNo,
    pageSize: defaultPageSize,
    search: searchText,
  };
  var dateFilterValues = getTripStartDateFilterValues();

  // const [selectedFilterStatus, setSelectedFilterStatus] = React.useState(parties.tripsTabFilter.selectedFilterStatus);
  // const [selectedFilterDate, setSelectedFilterDate] = React.useState(parties.tripsTabFilter.selectedFilterDate);

  const [selectedFilterStatus, setSelectedFilterStatus] = React.useState("ALL");
  const [selectedFilterDate, setSelectedFilterDate] = React.useState("ALL_MONTHS");

  const [tripTimelineActionOpen, setTripTimelineActionOpen] = useState(false);
  const [openingBalance, setOpeningBalance] = useState(false);
  const [openingBalanceData, setOpeningBalanceData] = useState("");

  const muiData = partyLedger ? user && user.singlePartyOpeningLogs && user.singlePartyOpeningLogs.length>0 ?[...partyLedger,...user.singlePartyOpeningLogs]:partyLedger : [];

  useEffect(() => {

    if (user && user.singlePartyLedgerData) {
      setPartyLedger(user.singlePartyLedgerData);
    }

  }, [user.singlePartyLedgerData])

  const onSearchBlur = debounce(query => {
    setPartyLedger([]);
    setLoadingText("Loading........");
    setCurrentPageNo(defaultPageNo)
    fetchPartyTrips(partId, false, query)
  }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
  const getPaginatedData = () => {
    fetchPartyTrips(partId, true)
  }
  const fetchPartyTrips = (partId, pagination, search) => {
    if (partId) {
      var singlePartyLedgerRequestData = {
        ...partyLedgerRequestData,
        ...{ customerId: partId },
        ...{
          filters: [
            {
              "filterKey": "customerId",
              "values": [partId]
            },
            {
              "filterKey": "tripStatus",
              "values": TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus]
            },
            {
              "filterKey": "startDate",
              "values": getDateRangeValue()
            }
          ]
        },
        ...{ status: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus] },
        ...{ startDateRange: dateFilterValues[selectedFilterDate]["startDateRange"] }
      };
      if (pagination) {
        singlePartyLedgerRequestData = {
          ...singlePartyLedgerRequestData,
          pageNo: currentPageNo + 1,
          pageSize: currentPageSize,
          searchText: searchText,
          merge: true
        }
      }
      if (search) {
        singlePartyLedgerRequestData.search = search;
      }

      if (singlePartyLedgerRequestData && singlePartyLedgerRequestData.startDateRange && singlePartyLedgerRequestData.startDateRange.startTimeEpoch && singlePartyLedgerRequestData.startDateRange.endTimeEpoch) {
        dispatchGetSinglePartyLedgerAction(singlePartyLedgerRequestData, () => {
          dispatchGetCollectionReminder(partId,
            () => {
              trackEvent("Single Party View", {
                'active_trips': user.singlePartyActiveTripCount,
                'due_amount': user.dueAmount,
                'outstanding_amount': user.partyBalance,
                'party_id': partId,
                'party_name': user.partyName,
                'party_mobile': user.partyMobile
              });
              setLoadingText("Sorry, no Trips found");
            }, () => {
              setLoadingText("Sorry, no Trips found");
            })
        });
      }
    }
  }
  const handleReminder = (date) => {
    let reminder = date ? Math.round(new Date(date) / 1000) : 0;
    if (parties && parties.collectionReminder && parties.collectionReminder.reminder) {
      dispatchUpdateCollectionReminder({
        customerId: partId,
        reminderDate: reminder
      }, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          if (partId) {
            fetchPartyTrips(partId)
          }
        }
      });
    } else {
      dispatchAddCollectionReminder({
        customerId: partId,
        reminderDate: reminder
      }, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          if (partId) {
            fetchPartyTrips(partId)
          }
        }
      });
    }
  }
  const handlePaymentDetailsClose = () => {
    setSelectedRow("")
    setDetailsOpen(false);
    fetchPartyTrips(partId)
  }

  const handleTransactDelete = () => {
      setSelectedRow("")
      setDetailsOpen(false);
      fetchPartyTrips(partId)
  }
  useEffect(() => {
    if (partId) {
      fetchPartyTrips(partId)
    }
  }, [dispatchGetSinglePartyLedgerAction]);
  const handleTripTimelineActionClose = (status) => {
    setTripTimelineActionOpen(status);
    setOpeningBalance(false);
    setOpeningBalanceData("")
    if (partId) {
      disPatchEmptySingleTripData();
      fetchPartyTrips(partId)
    }
  }
  const handleTripTimelineActionOpen = (status, tripId, e, dataIndex) => {
    e.preventDefault();
    e.stopPropagation();
    if (status == 'PAYMENT_RECEIVED') {
      handlePartyRow(muiData[dataIndex]);
    } else {
      if (tripId && tripId != 'openingBalance') {
        dispatchTripDetailsAction(tripId, () => {
          if (user.singleTripData) {
            setTripTimelineActionOpen(true);
          }
        });
      }else{
        setOpeningBalance(true);
        setOpeningBalanceData({
          ...muiData[dataIndex],
          partyBalance:muiData[dataIndex].amount,
          partyId:partId
        })
        setTripTimelineActionOpen(true);
      }
    }
  }

  useEffect(() => {
    setLoadingText("Loading........");
    setPartyLedger([]);
    if (changeFlag) {
      setCurrentPageNo(defaultPageNo)
      if (partId) {
        var singlePartyLedgerRequestData = {
          ...partyLedgerRequestData,
          ...{ customerId: partId },
          ...{
            filters: [
              {
                "filterKey": "customerId",
                "values": [partId]
              },
              {
                "filterKey": "tripStatus",
                "values": TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus]
              },
              {
                "filterKey": "startDate",
                "values": getDateRangeValue()
              }
            ]
          },
          ...{ status: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus] },
          ...{ startDateRange: dateFilterValues[selectedFilterDate]["startDateRange"] }
        };

        if (customFilterValue && customFilterValue.startTimeEpoch) {
          singlePartyLedgerRequestData.startDateRange = customFilterValue;
        }

        if (singlePartyLedgerRequestData && singlePartyLedgerRequestData.startDateRange && singlePartyLedgerRequestData.startDateRange.startTimeEpoch && singlePartyLedgerRequestData.startDateRange.endTimeEpoch) {
          dispatchGetSinglePartyLedgerAction(singlePartyLedgerRequestData,
            () => {
              trackEvent("Single Party View", {
                'active_trips': user.singlePartyActiveTripCount,
                'due_amount': user.dueAmount,
                'outstanding_amount': user.partyBalance,
                'party_id': partId,
                'party_name': user.partyName,
                'party_mobile': user.partyMobile
              });
              setLoadingText("Sorry, no Trips found");
            },
            () => {
              setLoadingText("Sorry, no Trips found");
            }
          );
        }
      }
    }

  }, [selectedFilterStatus, selectedFilterDate, customFilterValue]);


  const muiColumns = [
    {
      name: "startTime",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          if (rowIndex === muiData.length - 3) {
            return (
              <Fragment>
                <Waypoint
                  onEnter={() => {
                    if (user && user.singlePartyTripMaxPage && user.singlePartyTripMaxPage != currentPageNo) {
                      getPaginatedData()
                      setCurrentPageNo(currentPageNo + 1)
                    }
                  }}
                />
                <span>{value ? getDateInStringDDMMMYYYY(value) : 'N/A'}</span>
              </Fragment>
            );
          } else {
            return <span>{value ? getDateInStringDDMMMYYYY(value) : 'N/A'}</span>
          }
        }
      },
    },
    {
      name: "vehicleNumber",
      label: "Truck No",
      options: {
        filter: true,
        sort: false,
        // customBodyRenderLite: (dataIndex, rowIndex) => {
        //   return (
        //     <div className={classes.truckNoDiv}> <div>{muiData[dataIndex].vehicleNumberPrefixDweb}</div><div className={classes.mlV1}>{muiData[dataIndex].vehicleNumberMiddle}</div><div className={classes.divTruckNoSuffix}>{muiData[dataIndex].vehicleNumberSuffixDweb}</div></div >
        //   )
        // }

        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            (
              ( muiData && muiData[dataIndex] && muiData[dataIndex].id && muiData[dataIndex].id !='openingBalance')
                ?
                <div style={{ display: 'flex' }}>
                {muiData[dataIndex].vehicleNumArrayDweb && muiData[dataIndex].vehicleNumArrayDweb.map((item) => (
                  <div className={classes.vehileNumber}>{item}</div>
                ))
                }
              </div>: muiData && muiData[dataIndex] && muiData[dataIndex].id && muiData[dataIndex].id =='openingBalance'?<div className={classes.divLocation}>{muiData[dataIndex].displayName?muiData[dataIndex].displayName:''}</div>:<div className={classes.fw300}>N/A</div>
            )
          )
        }
      },
    },
    {
      name: "startDest",
      label: "Route",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            (
              (muiData[dataIndex].startLocation && muiData[dataIndex].destinationLocation && muiData[dataIndex].id && muiData[dataIndex].id !='openingBalance')
                ?
                < div className={classes.divLocation} > <div>{muiData[dataIndex].startLocation}</div><ArrowRightAltIcon className={classes.arrowRightV1} /><div>{muiData[dataIndex].destinationLocation}</div></div >
                :muiData[dataIndex].id && muiData[dataIndex].id =='openingBalance'?null:<div className={classes.fw300}>N/A</div>
            )
          )
        }
      },
    },
    // {
    //   name: "freight",
    //   label: "Freight",
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return <span>{value ? value : 'N/A'}</span>
    //     }
    //   },
    // },
    // {
    //   name: "pod_status",
    //   label: "POD",
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return <span>{value ? value : 'N/A'}</span>
    //     }
    //   },
    // },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            (
              (muiData[dataIndex] && muiData[dataIndex].status && muiData[dataIndex].id && muiData[dataIndex].id !='openingBalance')
                ?
                <div className={classes.statusDiv}> <FiberManualRecordIcon
              className={classes[muiData[dataIndex].status + '_BULLET']}
            ></FiberManualRecordIcon><div className={classes[muiData[dataIndex].status]}>{TRIP_STATUS_LABELS[muiData[dataIndex].status]}</div></div>
                :
                <div className={classes.fw300}></div>
            )
          )
        },
        /*customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div className={classes.statusDiv}> <FiberManualRecordIcon
              className={classes[value + '_BULLET']}
            ></FiberManualRecordIcon><div className={classes[value]}>{TRIP_STATUS_LABELS[value]}</div></div>
          )
        }*/
      },
    },
    {
      name: "amount",
      label: "Party Balance",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div className={classes.balance}>{numberFormat(Number(value))}</div>
        }
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        empty: false,
        download: false,
        searchable: false,
        viewColumns: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let status = muiData && muiData[dataIndex] && muiData[dataIndex].status ? muiData[dataIndex].status : ''
          let tripId = muiData && muiData[dataIndex] && muiData[dataIndex].id ? muiData[dataIndex].id : ''
          return (<ColumnActions>
            <ActionButton size="small" onClick={(e) => { handleTripTimelineActionOpen(status, tripId, e, dataIndex) }} className={classes.actionButton}>
              {tripId !='openingBalance'?TRIP_ACTIONS[status]:'Settle Opening Balance'}
            </ActionButton>
          </ColumnActions>);
        }
      },
    }
  ];
  const options = {
    rowsPerPage: 100,
    pagination: false,
    rowsPerPageOptions: [10, 100, 250],
    filterType: "multiselect",
    fixedHeader: true,
    tableBodyHeight: tableHeightWithSparklineSingle,
    selectableRows: 'none',
    searchOpen: true,
    search: false,
    jumpToPage: false,
    download: false,
    filter: false,
    print: false,
    sort: false,
    viewColumns: false,
    onRowClick: (rowData, rowMeta) => {
      handlePartyRow(muiData[rowMeta.dataIndex])
    },
    /*onCellClick: (colData, cellMeta, rowIndex) => {
      if (cellMeta.colIndex != 6) {
        handlePartyRow(muiData[cellMeta.rowIndex]);
      }
    },*/
    customToolbar: (data) => {
      return <>
        <div className={classes.divV5}>
          <div className={classes.mtV4}>
            <span>
              <div className={classes.divDateV1}>Date</div>
              <DateFilter fromSinglePartyTripsTab={true} dateValue={handleDateValue} />
            </span>
            <span className={classes.mlV2}>
              <div className={classes.divTripStatus}>Trip Status</div>
              <TripStatusFilter fromSinglePartyTripsTab={true} status={handleTripStatusValue} />
            </span>
          </div>
          <Button variant="contained" classes={{ root: classes.viewPDFCta, label: classes.label, }} color="primary" onClick={() => { handlePartyPdf() }}>
            <PictureAsPdfIcon />&nbsp;View PDF
          </Button>
        </div>
      </>
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

    },
    searchProps: {
      variant: "outlined",
      //value: searchText,
      InputProps: {
        startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
      },
      onBlur: (e) => {
      },
      onKeyUp: (e) => {
      },
      onKeyDown: (event) => {
        if (event.keyCode === 27) {
        }
      }
    },
    searchPlaceholder: 'Search Trips',
    onSearchChange: (val) => {
      let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
      setSearchText(value);
      if (value && value.length > 1) {
        onSearchBlur(value);
      } else if (searchText && value && value.trim().length <= 1) {
        setSearchText("");
        onSearchBlur("");
      }else{
        setSearchText("");
        onSearchBlur("");
      }
    },
    onSearchClose: () => {
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      /*if (searchQuery && searchQuery.trim().length > 0) {
        searchQuery = searchQuery.trim()
        currentRow.forEach((col, index) => {
          if (index == 0) {
            col = getDatePickerDateInStringDDMMMYYYY(new Date(Number(col) * 1000));
          }
          if (col && col.toString().toUpperCase().indexOf(searchQuery.toUpperCase()) >= 0) {
            isFound = true;
          }
        });
      } else {
        isFound = true;
      }*/
      return true;
    },
    textLabels: {
      body: {
        noMatch: loadingText,
        toolTip: "Sort",
        columnHeaderTooltip: column => `Sort for ${column.label}`
      }
    }
  };

  const handlePartyPdf = () => {
    setViewReportDialog(true);
  }
  const handleViewReportClose = (val) => {
    setViewReportDialog(false);
    if(val && val == "trip"){
      setPdfOpen(true);
    }else if(val && val=="passbook"){
      setPassbookPdfOpen(true)
    }
  }
  const handleClose = () => {
    setPdfOpen(false);
  }
  const handlePassbookClose = () => {
    setPassbookPdfOpen(false);
  }

  const handleDateValue = (value) => {
    if (value == "CUSTOM") {
      setCustomFilter(true);
    } else {
      setSelectedFilterDate(value);
      setCustomFilter(false);
      setCustomFilterValue({});
    }
    dispatchUpdateTripsTabFilter({
      selectedFilterStatus: selectedFilterStatus,
      selectedFilterDate: value
    });
    setChangeFlag(true);
  }

  const handleTripStatusValue = (value) => {
    setSelectedFilterStatus(value);
    dispatchUpdateTripsTabFilter({
      selectedFilterStatus: value,
      selectedFilterDate: selectedFilterDate
    });
    setChangeFlag(true);
  }

  const handlePartyRow = (data) => {
    if (data && data.id && data.journeyId && data.id !='openingBalance') {
      history.push({
        pathname: `/trips/view/${data.journeyId}`,
        state: {
          id: 7,
          tripData: data,
          tripView: true,
          pageTitle: 'Trip Details',
          pageSubTitle: data && data.vehicle && data.vehicle.vehicleNumber ? data.vehicle.vehicleNumber : ''
        }
      });
    }else if (data && data.id && data.id =='openingBalance') {
      setSelectedRow(data);
      setDetailsOpen(true)
    }
  }

  const handleCustomFilterClose = () => {
    setCustomFilter(false);
  }

  const handleCustomFilterConfirm = (value) => {
    setSelectedFilterDate("CUSTOM");
    setCustomFilter(false);
    setCustomFilterValue(value);
  }

  return (<>
    <TapLayout>
      <Grid container justify="flex-start" spacing={3} direction="row">
        <Grid item>
          <TopCard title='Total Party Balance' color="#0b1323" infoIcon={true} cardValue={numberFormat(user && user.partyBalance ? user.partyBalance : 0)} infoTitle={"Party Balance"} infoText={"The total balance amount to be collected for all the trips with this party in this period"} color={"blue"} />
        </Grid>
        <Grid item>
          <TopCard title='Total active trips' color="#6b778c" infoIcon={true} cardValue={user && user.singlePartyActiveTripCount ? user.singlePartyActiveTripCount : 0} infoTitle={"Active Trips"} infoText={"The number of trips with a balance amount from this party in this period"} color={"green"} />
        </Grid>
        <Grid item>
          <TopCard title='Collection Reminder' infoTitle='Collection Reminder' infoText='' color="#000" infoIcon={false}
            cardValue={parties && parties.collectionReminder && parties.collectionReminder.reminder ? <span style={{ cursor: 'pointer' }} onClick={(e) => { setDateSelectOpen(true) }}>{moment(parties.collectionReminder.reminder).format('DD/MM/YYYY')}</span> : <Button variant="contained" className={classes.reminderButton} color="primary" onClick={(e) => { setDateSelectOpen(true) }}>Add Reminder</Button>} />
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              margin='none'
              style={{ display: 'none' }}
              autoOk
              fullWidth
              minDate={tomorrow}
              open={dateSelectOpen}
              value={parties && parties.collectionReminder && parties.collectionReminder.reminder ? parties.collectionReminder.reminder : new Date()}
              onClose={(e) => { setDateSelectOpen(false) }}
              variant='dialog'
              inputVariant='outlined'
              id='date-reminder-complete-dialog'
              label=''
              format='dd MMM yyyy'
              onChange={date => {
                handleReminder(date)
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
      <div style={{ marginTop: 16 }}>
        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
      </div>
    </TapLayout>
    {viewReportDialog && <CardSelectionDialog open={viewReportDialog} title={"Select Report"} onClose={handleViewReportClose} />}
    {pdfOpen &&
      <ReportsDialog open={pdfOpen} name={"Export Party Ledger Report"} fromSinglePartyPage={true} partyIdFromSingleParty={partId} onClose={handleClose} />
    }
    {passbookPdfOpen &&
      <PassBookReportDialog open={passbookPdfOpen} name={"Export Party Passbook Report"} fromSinglePartyPage={true} partyIdFromSingleParty={partId} onClose={handlePassbookClose} />
    }
    {tripTimelineActionOpen && <TripTimelineAction trip={{}} settleOpeningBalance={openingBalance} openingBalanceData={openingBalanceData} open={tripTimelineActionOpen} onClose={handleTripTimelineActionClose} />}
    {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}
    {detailsOpen && <OpeningBalanceDetailsSideBar rightSideBarOpen={detailsOpen} onClose={handlePaymentDetailsClose} selectedRow={selectedRow} onDelete={handleTransactDelete} />}

  </>)
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  disPatchEmptySingleTripData: () => dispatch(emptySingleTripData()),
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getTripDetailsV3(tripId, onSuccess, onError)),
  dispatchGetCollectionReminder: (partyId, onSuccess, onError) =>
    dispatch(getSinglePartyCollectionReminder(partyId, onSuccess, onError)),
  dispatchAddCollectionReminder: (data, onSuccess, onError) =>
    dispatch(addPartyReminder(data, onSuccess, onError)),
  dispatchUpdateCollectionReminder: (data, onSuccess, onError) =>
    dispatch(updatePartyReminder(data, onSuccess, onError)),
  dispatchGetSinglePartyLedgerAction: (requestData, onSuccess) =>
    dispatch(
      getSinglePartyLedgerDataV2(
        requestData,
        () => {
          if (onSuccess) {
            onSuccess();
          }
        },
        () => {
        }
      )
    ),
  dispatchUpdateTripsTabFilter: (data) => dispatch(updateTripsTabFilter(data))
});
const TripsTabWithRouter = withRouter(TripsTab);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsTabWithRouter);